import SiafLiteApiRepository from "../../external/siafLiteApi";

class ModulosService {
  constructor() {
    this.urlBase = "/painel-controle/modulos";
    this.urlBaseEvent = `/event${this.urlBase}`;
  }

  getAll(filter) {
    return new SiafLiteApiRepository(this.urlBaseEvent).get(filter);
  }
}

export default ModulosService;
